(() => {
  if (window.SeifeThemeVisuals) return;
  // Visual identities only: separate taxonomies, never subscription handoff mappings.
  // The approved subscription palette is the semantic visual authority.
  const palette = {
    forest:['#dfebd7','#507448','forest'], fruit:['#f0dce4','#a2637a','fruit'],
    flower:['#efe0ea','#a26c8f','flower'], warm:['#efddcd','#a4794b','flame'],
    gentle:['#e7e2f0','#867399','drop'], fresh:['#dce9e5','#56847c','leaf'],
    passion:['#efdcd6','#a56960','heart'], neutral:['#e8eadb','#59643d','spark']
  };
  const tokens = {
    finder: {
      'frisch-natuerlich': palette.fresh,
      'blumig-elegant': palette.flower,
      'fruchtig-lebensfroh': palette.fruit,
      'holzig-erdverbunden': palette.forest,
      'sanft-pflegend': palette.gentle,
      'orientalisch-luxurioes': palette.warm,
      'wellness-entspannung': ['#dce9e5', '#56847c', 'water'],
      'verspielt-besonders': ['#eee6c9', '#a58a3e', 'spark'],
      // Transitional display support for the still-deployed provisional config.
      // This does not create choices or infer subscriptionThemeId.
      wald:palette.forest,beeren:palette.fruit,blumig:palette.flower,wuerzig:palette.warm,
      sanft:palette.gentle,frisch:palette.fresh,leidenschaft:palette.passion
    },
    subscription: {
      'frisch-natuerlich':palette.fresh,'blumig-elegant':palette.flower,
      'fruchtig-lebensfroh':palette.fruit,'holzig-erdverbunden':palette.forest,
      'sanft-pflegend':palette.gentle,'wellness-entspannung':['#dce9e5','#56847c','water'],
      'verspielt-besonders':['#eee6c9','#a58a3e','spark'],'orientalisch-luxurioes':palette.warm,
      wald:palette.forest,beeren:palette.fruit,blumig:palette.flower,wuerzig:palette.warm,
      sanft:palette.gentle,frisch:palette.fresh,leidenschaft:palette.passion
    },
    skin: {
      'region:hair':[...palette.forest.slice(0,2),'hair'],
      'region:face':[...palette.passion.slice(0,2),'face'],
      'region:hands':[...palette.gentle.slice(0,2),'hands'],
      'region:body':[...palette.fresh.slice(0,2),'person'],
      'need:oily':palette.fresh,'need:dry':palette.gentle,
      'need:flaky':[...palette.gentle.slice(0,2),'water'],
      'need:demanding':palette.passion,'need:balanced':[...palette.forest.slice(0,2),'water'],
      'wish:clear':palette.fresh,'wish:rich':palette.passion,'wish:gentle':palette.gentle,
      'scent:herbal':palette.fresh,'scent:floral':palette.flower,
      'scent:fruity':palette.fruit,'scent:woody':palette.forest,'scent:any':palette.neutral
    },
    giftbox: {
      'frisch-natuerlich':palette.fresh,'blumig-elegant':palette.flower,
      'fruchtig-lebensfroh':palette.fruit,'holzig-erdverbunden':palette.forest,
      'sanft-pflegend':palette.gentle,'wellness-entspannung':['#dce9e5','#56847c','water'],
      'verspielt-besonders':['#eee6c9','#a58a3e','spark'],'orientalisch-luxurioes':palette.warm,
      neutral:palette.neutral,green:palette.forest,rose:palette.flower,
      earth:palette.warm,surprise:['#eee6c9','#a58a3e','spark']
    },
    b2bRecipient: {
      customer:[...palette.fresh.slice(0,2),'person'],
      team:[...palette.forest.slice(0,2),'team'],
      partner:[...palette.gentle.slice(0,2),'friends'],
      occasion:[...palette.warm.slice(0,2),'spark']
    },
    recipient: {
      partner: ['#f0dfe4', '#a2637a', 'couple'], family: ['#e7e2f0', '#867399', 'family'],
      friend: ['#f4e2c8', '#b0783e', 'friends'], team: ['#dfebd7', '#507448', 'team'],
      self: ['#dce9e5', '#56847c', 'person'], housewarming: ['#eee6c9', '#a58a3e', 'house']
    }
  };
  const person = (x, y) => `<circle cx="${x}" cy="${y}" r="5"/><path d="M${x-9} ${y+21}v-6a9 9 0 0 1 18 0v6"/>`;
  const paths = {
    leaf: '<path d="M17 48C8 24 26 13 48 14c0 25-13 39-31 34Zm0 0 24-25M28 36l-2-10m10 3 8 1"/>',
    flower: '<path d="M32 48v9m0-8c-7 0-11-5-10-11-10 1-14-11-7-16 0-10 12-14 17-6 6-8 17-4 17 6 7 6 3 17-7 16 1 6-3 11-10 11Z"/><circle cx="32" cy="30" r="6"/>',
    fruit: '<circle cx="24" cy="36" r="11"/><circle cx="42" cy="38" r="11"/><path d="M25 25c0-10 10-14 19-13-1 9-7 15-19 13Zm6-7-7-8"/>',
    forest: '<path d="m24 9-15 22h9L8 44h32L30 31h9L24 9Zm1 35v12m16-35 12 18h-7l9 12H43m2 0v5"/>',
    drop: '<path d="M32 8c-5 12-18 22-18 33a18 18 0 0 0 36 0C50 30 37 20 32 8Z"/><path d="M23 39c-2 6 2 11 7 12"/>',
    flame: '<path d="M33 8c3 17-12 18-11 30-6-1-6-9-6-9C3 49 24 62 40 54c17-10 9-29 2-34 2 12-8 16-9 5Z"/><path d="M32 36c-8 10-9 18 0 20 12-2 9-12 0-20Z"/>',
    water: '<path d="M9 38c8-10 13 10 23 0s15 10 23 0M9 49c8-10 13 10 23 0s15 10 23 0"/><path d="M26 26a9 9 0 0 1 17 0m-9-18V4m-14 9-4-4m32 4 4-4"/>',
    spark: '<path d="m31 8 5 15 16 5-16 5-5 16-5-16-15-5 15-5 5-15Zm17 33 3 7 7 3-7 3-3 7-3-7-7-3 7-3 3-7"/>',
    heart: '<path d="M32 53 12 34C-4 18 18 4 32 20 46 4 68 18 52 34L32 53Z"/>',
    person: person(32, 21)+'<path d="m14 11 2 5m31-5-2 5M28 48l4 5 4-5"/>',
    couple: person(20,22)+person(44,22)+'<path d="m27 11 5 4 5-4"/>',
    friends: person(20,20)+person(44,24)+'<path d="m27 12 7-5m-8 42 12-2"/>',
    family: person(15,20)+person(49,20)+person(32,32),
    team: person(15,30)+person(32,16)+person(49,30),
    house: '<path d="m8 29 24-20 24 20M14 25v29h36V25M27 54V38h10v16M21 29h3m16 0h3"/><path d="M43 10v9M8 10v8m-4-4h8"/>'
    ,face:'<path d="M17 28c0-23 30-23 30 0v9c0 13-8 20-15 20S17 50 17 37v-9Z"/><path d="M17 29c8-2 15-8 17-15 2 8 7 12 13 14M23 34h3m12 0h3M28 44c3 2 5 2 8 0"/>',
    hair:'<path d="M15 51V30C15 3 49 3 49 30v21M21 52V31c0-18 22-18 22 0v21M27 51V33m10 0v18"/><path d="M11 40c-4 6-4 12 1 16m41-16c4 6 4 12-1 16"/>',
    hands:'<path d="M19 52 9 39c-5-6 1-11 6-6l6 5V18c0-7 8-7 8 0v13V11c0-7 8-7 8 0v20V16c0-7 8-7 8 0v18-10c0-7 8-7 8 0v18c0 10-9 16-18 16H24Z"/>'
  };
  const apply = (node, taxonomy, id) => {
    node.classList.add('commerce-choice');
    const [paper, ink, icon] = tokens[taxonomy]?.[id] || ['#e8eadb', '#59643d', 'spark'];
    node.style.setProperty('--illustration-paper', paper);
    node.style.setProperty('--illustration-ink', ink);
    const span = document.createElement('span'); span.className = 'commerce-illustration'; span.setAttribute('aria-hidden', 'true');
    span.innerHTML = `<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="32" cy="32" r="30" fill="${ink}" fill-opacity=".06" stroke="none"/>${paths[icon]}</svg>`;
    return span;
  };
  // Exact option identity and complete value mapping, never product titles/tags.
  const standardThemes = [
    'frisch-natuerlich', 'blumig-elegant', 'fruchtig-lebensfroh', 'holzig-erdverbunden',
    'sanft-pflegend', 'wellness-entspannung', 'verspielt-besonders', 'orientalisch-luxurioes'
  ];
  // Display translations are aliases only; never use them as variant identity.
  const localizedThemes = [
    ['Fresh & Natural', 'Frais & Naturel', 'منعش وطبيعي'],
    ['Floral & Elegant', 'Floral & Élégant', 'زهري وأنيق'],
    ['Fruity & Cheerful', 'Fruité & Joyeux', 'فاكهي ومبهج'],
    ['Woody & Earthy', 'Boisé & Terreux', 'خشبي وترابي'],
    ['Gentle & Caring', 'Doux & Soin', 'لطيف وعناية'],
    ['Wellness & Relaxation', 'Bien-être & Détente', 'عافية واسترخاء'],
    ['Playful & Special', 'Ludique & Spécial', 'مرح ومميز'],
    ['Oriental & Luxurious', 'Oriental & Luxueux', 'شرقي وفاخر']
  ];
  const normalizeTheme = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/ü/g, 'u').replace(/[^a-z0-9]+/g, '');
  const themeId = value => {
    const localizedIndex = localizedThemes.findIndex(labels => labels.some(label => label.normalize('NFC') === String(value || '').trim().normalize('NFC')));
    if (localizedIndex !== -1) return standardThemes[localizedIndex];
    const key = normalizeTheme(value).replace(/natuerlich/g, 'naturlich').replace(/luxurioes/g, 'luxurios');
    return standardThemes.find(id => normalizeTheme(id).replace(/natuerlich/g, 'naturlich').replace(/luxurioes/g, 'luxurios') === key);
  };
  // Older Shopify gifts retain the native "Title" option name. Recognise it
  // only when the complete eight approved theme values are present below.
  const isThemeOption = name => ['title', 'themenwelt', 'themenwelten', 'theme', 'themes', 'theme world', 'univers', 'univers olfactif', 'العالم العطري'].includes(String(name || '').trim().toLowerCase());
  const mapThemes = (name, values) => {
    if (!isThemeOption(name) || values.length < 8) return null;
    const ids = values.map(themeId);
    const mapped = ids.filter(Boolean);
    return mapped.length === 8 && new Set(mapped).size === 8 ? ids : null;
  };
  const decorateVariant = (node, id) => {
    const illustration = apply(node, 'subscription', id);
    node.classList.remove('commerce-choice');
    node.classList.add('theme-variant-picker__button');
    node.prepend(illustration);
  };
  // The master select stays authoritative. All existing change/cart hooks run.
  const selectPickers = new WeakMap();
  const enhanceSelect = (select, variants) => {
    if (!select.isConnected) return null;
    const previous = selectPickers.get(select);
    const hadFocus = document.activeElement === select || previous?.wrapper.contains(document.activeElement);
    previous?.cleanup();
    if (!variants.length) return null;
    const names = variants[0].productOptionNames;
    if (!Array.isArray(names) || !names.length || !variants.every(v => Array.isArray(v.variantOptions) && v.variantOptions.length === names.length)) return null;
    const dimensions = names.map((name, index) => [...new Set(variants.map(v => v.variantOptions[index]))]);
    const index = names.findIndex((name, i) => mapThemes(name, dimensions[i]));
    if (index < 0 || new Set(variants.map(v => JSON.stringify(v.variantOptions))).size !== variants.length) return null;
    const ids = mapThemes(names[index], dimensions[index]);
    const wrapper = document.createElement('div'); wrapper.className = 'theme-variant-picker';
    const choices = document.createElement('div'); choices.className = 'theme-variant-picker__choices';
    choices.setAttribute('role', 'group'); choices.setAttribute('aria-label', select.getAttribute('aria-label') || names[index]);
    const selectedName = document.createElement('span'); selectedName.className = 'theme-variant-picker__selected';
    selectedName.setAttribute('aria-live', 'polite');
    const otherControls = [];
    const current = () => variants.find(v => String(v.variantId) === select.value);
    const choose = (dimension, value) => {
      if (select.disabled) return;
      const previous = current() || (names.length === 1 ? variants[0] : null); if (!previous) return;
      const wanted = previous.variantOptions.map((v, i) => i === dimension ? value : v);
      const next = variants.find(v => v.variantOptions.every((v, i) => v === wanted[i]));
      if (!next) return;
      select.value = String(next.variantId);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    };
    dimensions[index].forEach((value, i) => {
      const button = document.createElement('button'); button.type = 'button';
      button.title = value; button.setAttribute('aria-label', value); button.dataset.themeValue = value;
      if (ids[i]) decorateVariant(button, ids[i]);
      else {
        button.className = 'theme-variant-picker__button theme-variant-picker__standard';
        button.textContent = value;
      }
      button.addEventListener('click', () => choose(index, value)); choices.append(button);
    });
    wrapper.append(choices, selectedName);
    names.forEach((name, i) => {
      if (i === index || dimensions[i].length === 1) return;
      const label = document.createElement('label'); label.className = 'theme-variant-picker__other'; label.textContent = name;
      const control = document.createElement('select');
      dimensions[i].forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; control.append(option); });
      control.addEventListener('change', () => choose(i, control.value));
      otherControls.push({ control, index: i }); label.append(control); wrapper.append(label);
    });
    const sync = () => {
      const active = current();
      // Stale remembered identity: expose the original fallback, not a guess.
      select.hidden = !!active || names.length === 1; wrapper.hidden = !select.hidden;
      if (!active && names.length !== 1) return;
      selectedName.textContent = active ? (select.selectedOptions[0]?.textContent || active.variantOptions[index]) : select.selectedOptions[0]?.textContent;
      const possible = (dimension, value) => variants.some(v => {
        const option = [...select.options].find(o => o.value === String(v.variantId));
        return option && !option.disabled && v.variantOptions.every((v, i) => v === (i === dimension ? value : active?.variantOptions[i]));
      });
      choices.querySelectorAll('button').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.themeValue === active?.variantOptions[index]));
        button.disabled = select.disabled || !possible(index, button.dataset.themeValue);
      });
      otherControls.forEach(({ control, index: i }) => {
        control.value = active.variantOptions[i]; control.disabled = select.disabled;
        [...control.options].forEach(option => { option.disabled = !possible(i, option.value); });
      });
    };
    select.dataset.themePicker = 'true'; select.after(wrapper); select.addEventListener('change', sync);
    // Cart code already locks/unlocks the master select.
    const observer = new MutationObserver(() => {
      if (!select.isConnected) { observer.disconnect(); return; }
      sync();
    });
    observer.observe(select, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'selected'] });
    selectPickers.set(select, { wrapper, cleanup: () => {
      observer.disconnect(); select.removeEventListener('change', sync);
      wrapper.remove(); select.hidden = false; delete select.dataset.themePicker; selectPickers.delete(select);
    } });
    sync();
    if (hadFocus && select.hidden) choices.querySelector('[aria-pressed=true]')?.focus({ preventScroll: true });
    return wrapper;
  };
  window.SeifeThemeVisuals = Object.freeze({ apply, mapThemes, decorateVariant, enhanceSelect });
  // Only the business-gift recipient selector is equivalent to finder recipients.
  // Product, planning, manufacturing and contact-form choices remain untouched.
  document.querySelectorAll('[data-refined-program="gifts"]').forEach(host => {
    let config;
    try { config = JSON.parse(host.querySelector('[data-refined-config]')?.textContent || '{}'); } catch { return; }
    const titles = config.steps?.[0]?.options?.map(option => option.title);
    if (!Array.isArray(titles) || titles.length !== 4) return;
    const decorate = () => host.querySelectorAll('.b2b-inquiry__choices button').forEach(node => {
      const title = node.querySelector('strong')?.textContent.trim();
      const index = titles.indexOf(title);
      if (index < 0) return;
      if (!node.classList.contains('commerce-choice')) node.classList.add('commerce-choice');
      if (!node.querySelector('.commerce-illustration')) node.prepend(apply(node, 'b2bRecipient', ['customer','team','partner','occasion'][index]));
      node.setAttribute('aria-pressed', String(node.classList.contains('is-selected')));
    });
    new MutationObserver(decorate).observe(host, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
    decorate();
  });
})();
